'use strict'
const _ = require('lodash')
const {OPENED_EXPERIMENTS} = require('../../constants/store')

module.exports = {
  isExperimentOpen(store, experiment) {
    return _.includes(store.getValue(OPENED_EXPERIMENTS), experiment)
  }
}